import React from 'react';
import { Autocomplete } from '../../MUI/autocomplete/Autocomplete';
import { DURATION_OPTIONS } from '../../../constants/duration';
import { formatDuration } from '../../../helpers/formatDuration';

type TAutocompleteQuarterHourProps = {
  label?: string;
  value?: number | null;
  disabled?: boolean;
  onChange?: (value: any) => void;
  defaultDuration?: number | null;
}

const options = DURATION_OPTIONS;

export const DurationAutocomplete: React.FC<TAutocompleteQuarterHourProps> = ({
  label,
  value,
  disabled,
  onChange,
  defaultDuration,
}) => {

  return (
    <Autocomplete
      disabled={disabled}
      label={label}
      options={options}
      getOptionLabel={(opt) => {
        const minutes = `${opt} min`;
        const hours = opt >= 60 ? ` (${formatDuration(opt).replace(' ', '')})` : '';
        const defaultSuffix = defaultDuration != null && opt === defaultDuration ? ' (Padrão)' : '';
        return `${minutes}${hours}${defaultSuffix}`;
      }}
      onChange={(_, val) => onChange?.(val)}
      value={value}
    />
  );
};
